import React, { Component } from 'react';
import { Layout } from './Layout';
import { Route } from 'react-router';
import AdminHome from './AdminHome';
import BoardsAdminList from './Boards/BoardsAdminList';
import AddEditBoard from './Boards/AddEditBoard';
import BoardMemberEdit from './BoardMembers/BoardMemberEdit';
import ProfilesAdminList from './Profiles/ProfilesAdminList';
import EditProfile from './Profiles/EditProfile';
import ReportsList from './Reports/ReportsList';
import MembershipExpiration from './Reports/MembershipExpiration';
import BoardVacancy from './Reports/BoardVacancy';
import AdminApplication from './Application/AdminApplication';
import Dropdowns from './Codes/Dropdowns';

export default class Admin extends Component {

    render() {
        return(
            <Layout children={this.props.children}>
                <Route exact path='/admin' component={AdminHome} />
                <Route exact path='/admin/boards' component={BoardsAdminList} />
                <Route exact path='/admin/boards/:id' component={AddEditBoard} />
                <Route exact path='/admin/boardmember/:id' component={BoardMemberEdit} />
                <Route exact path='/admin/profiles' component={ProfilesAdminList} />
                <Route exact path='/admin/profiles/:id' component={EditProfile} />
                <Route exact path='/admin/reports' component={ReportsList} />
                <Route exact path='/admin/reports/membershipexpiration' component={MembershipExpiration} />
                <Route exact path='/admin/reports/boardvacancy' component={BoardVacancy} />
                <Route exact path='/admin/application/:id' component={AdminApplication} />
                <Route exact path='/admin/dropdowns' component={Dropdowns} />
            </Layout>
        )
    }
}